/*
* Project: LegalPlace assistant
* File: src/components/buy/mail_section.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
// importing things
import { LP_STATE_PAYMENT, LP_STATE_WIZARD, setAppState } from '../../redux/actions/app_state';
import { updateMailFromInput } from '../../redux/actions/account_settings';
import LpPayment from '../../logic/payment';
import lpevents from '../../tracking/lpevents';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';

// the check of mail existance here
class _MailSection extends Component {
  constructor(props) {
    super(props);
    this.updateMyMail = this.updateMyMail.bind(this);
    this.toThePayment = this.toThePayment.bind(this);
    this.has_error = false;
    // The initialization of payment system while the guy writes down the mail
    if (typeof window.lp_payment === 'undefined') {
      window.lp_payment = new LpPayment();
    }
  }

  componentDidMount() {
    // this case may give us the false effect we are waiting for
    lpevents.track('Reached email');
    lpevents.trackGTMCheckoutStep(2, 'Votre adresse email', lpApp.getState().contract)
    /*
    * Adwords Conversion tracking
    */
    lpevents.adwordsConversion({
      google_conversion_value: 0.01,
    });
  }

  updateMyMail(evt) {
    // console.log(evt.target.value);
    this.props.updateMail(evt.target.value);
  }

  toThePayment() {
    // saveMail(this.props.value);
    // this.props.pass0(this.props.value);
    this.props.goForward();
  }

  render(){
    return (
      <div className="wizard-content" style={{}}>
        <div className="wizard-email">
          <div className={`form-group${this.props.has_error ? ' error' : ''}`}>
            <label>{lpApp.references.customs.get('email_section_label') === 'NONE' ? _lp('Adresse email') : lpApp.references.customs.get('email_section_label')}</label>
            <input type="mail" name="email" onChange={evt => this.updateMyMail(evt)} value={this.props.value} className="form-control" style={{ marginTop: '10px', maxWidth: '360px', width: '100%' }} />
            {this.props.has_error && <span className="help-block">{_lp('Veuillez saisir une adresse email valide.')}</span>}
            <div className="helper">
              <i className="icn-info-o" />
              {lpApp.references.customs.get('email_section_warning') === 'NONE' ? _lp('Nous ne partagerons vos informations avec personne') : lpApp.references.customs.get('email_section_warning')}
            </div>
          </div>
        </div>
        <p>
          {_lp('Conformément à la Loi Informatique et Libertés et Règlement général sur la protection des données (RGPD), vous disposez d’un droit d’accès, de modification, de suppression et d’opposition au traitement de vos données à caractère personnel.')}
        </p>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  value: state.account_settings.mail,
  has_error: state.error.mail,
});

const mapDispatchToProps = dispatch => ({
  goForward: () => {
    // check the existance here
    dispatch(setAppState(LP_STATE_PAYMENT));
  },
  goBackward: () => {
    dispatch(setAppState(LP_STATE_WIZARD));
  },
  updateMail: (val) => {
    dispatch(updateMailFromInput(val));
  },
  pass0: () => {
    // dispatch(buildQuery(mail))

  },
});

const MailSection = connect(mapStateToProps, mapDispatchToProps)(_MailSection);

export default MailSection;



// WEBPACK FOOTER //
// ./src/components/buy/mail_section.js